/* eslint-disable max-len */
import HttpService from '../services/HttpService'

const {
  REACT_APP_AUTH_API_URL,
  REACT_APP_STORAGE_API_URL,
  REACT_APP_MODEL_API_URL,
  REACT_APP_SIMULATION_API_URL,
} = process.env

export const authApi = new HttpService({ baseURL: REACT_APP_AUTH_API_URL })
export const storageApi = new HttpService({ baseURL: REACT_APP_STORAGE_API_URL })
export const modelApi = new HttpService({ baseURL: REACT_APP_MODEL_API_URL })
export const simulationApi = new HttpService({ baseURL: REACT_APP_SIMULATION_API_URL })
